import { Message } from '@progress/kendo-angular-conversational-ui';

export interface ChatUser {
  id: string;
  name: string;
  avatarUrl?: string;
}

export interface MentionMessage extends Message {
  mentionedUserIds?: string[];
}

/**
 * Regex to detect mention tokens in the form @[userId:displayName]
 */
export const MENTION_PATTERN = /@\[(\w+):(.+?)\]/g;

/**
 * Extract all mentioned user IDs from a message string.
 */
export function extractMentionedUserIds(text: string): string[] {
  const ids: string[] = [];
  let match: RegExpExecArray | null;
  const re = new RegExp(MENTION_PATTERN.source, MENTION_PATTERN.flags);
  while ((match = re.exec(text)) !== null) {
    ids.push(match[1]);
  }
  return ids;
}

/**
 * Replace mention tokens with styled HTML spans for display.
 */
export function replaceMentionsWithHtml(text: string): string {
  return text.replace(
    /@\[(\w+):(.+?)\]/g,
    '<span class="mention" data-user-id="$1">@$2</span>'
  );
}
